module.exports = __webpack_public_path__ + "img/fase3Capture-play.d7309655.jpg";